import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Modifier (props)
// ============================================================

// Core
// ============================================================
export const CheckboxStyle = styled.div`
  /* Parent styles
  ------------------------------- */

  /* Child element styles
  ------------------------------- */
  position: relative;
  display: flex;
  align-items: center;
  width: 100%; /* percents.hundred */
  justify-content: flex-start;
  span.checkbox-award {
    margin-top: unset !important;
    margin-right: 1em;
  }
  .fake-input {
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
  }

  .check-icon {
    width: 12px;
    display: none;
    margin-bottom: 1px;
  }

  .fake-checkbox {
    height: 18px;
    width: 18px;
    flex: 0 0 18px;
    -webkit-border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    -moz-border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    -khtml-border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    border: 2px solid ${VARIABLES.COLORS.BLUE_3};
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 11px;
    background-color: ${VARIABLES.COLORS.GRAY_12};
    word-break: break-all;
    margin-top: 3px;
    /* margin-bottom: 3px; */
  }

  .fake-label {
    color: black;
  }

  .real-input {
    display: none;
    position: absolute;
    top: 0;
    left: 0;

    &:checked ~ .fake-input {
      .check-icon {
        display: block;
      }
    }
  }

  &.is-disabled {
    pointer-events: none;

    .fake-checkbox {
      background-color: ${VARIABLES.COLORS.GRAY_8};
    }

    &.is-checked .fake-checkbox {
      background-color: ${VARIABLES.COLORS.GRAY_10};
    }
  }

  /* States
  ------------------------------- */
  &.is-checked {
    .fake-checkbox {
      background-color: ${VARIABLES.COLORS.BLUE_1};
      border-color: ${VARIABLES.COLORS.BLUE_1};
    }
  }

  &.is-checked-sub {
    .fake-checkbox {
      background-color: ${VARIABLES.COLORS.BLUE_1};
      border-color: ${VARIABLES.COLORS.BLUE_1};
    }
  }

  /* Modifiers
  ------------------------------- */
  &.semibold-label {
    .fake-label {
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
    }
  }

  &.is-radio-type {
    .fake-input {
      .fake-checkbox {
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        -khtml-border-radius: 50%;
        border-radius: 50%;
        position: relative;
        margin-top: 4px;

        .check-icon {
          display: none;
        }

        &:after {
          content: '';
          display: none;
          position: absolute;
          width: 70%;
          height: 70%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background-color: ${VARIABLES.COLORS.BLUE_1};
          -webkit-border-radius: 50%;
          -moz-border-radius: 50%;
          -khtml-border-radius: 50%;
          border-radius: 50%;
        }
      }
    }

    &.is-checked {
      .fake-checkbox {
        background-color: white;

        &:after {
          display: block;
        }
      }
    }
  }

  &.inline {
    width: auto;
    margin-right: 25px;

    &:last-child {
      margin-right: 0;
    }
  }

  /* States with modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    .fake-checkbox {
      height: 17px;
      width: 17px;
      flex: 0 0 17px;
      margin-right: 10px;
    }
  }

  @media all and (max-width: 1440.98px) {
    .check-icon {
      width: 11px;
    }

    .fake-checkbox {
      height: 16px;
      width: 16px;
      flex: 0 0 16px;
      margin-right: 9px;
      border-radius: 4px;
    }
  }

  @media all and (max-width: 1366.98px) {
    .fake-checkbox {
      height: 15px;
      width: 15px;
      flex: 0 0 15px;
      margin-right: 8px;
      margin-top: 2px;
    }
  }

  @media all and (max-width: 1280.98px) {
    .check-icon {
      width: 10px;
    }

    .fake-checkbox {
      height: 14px;
      width: 14px;
      flex: 0 0 14px;
      margin-right: 7px;
      border-radius: 3px;
    }
  }

  @media all and (max-width: 1024.98px) {
    .check-icon {
      width: 9px;
    }

    .fake-checkbox {
      height: 13px;
      width: 13px;
      flex: 0 0 13px;
      margin-right: 6px;
    }
  }
`
